var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTranslateIconOff = function SvgTranslateIconOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 10,
    rx: 0.5,
    fill: "white",
    stroke: "#626262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15V6C16 5.44772 15.5523 5 15 5H10.9142C10.649 5 10.3946 5.10536 10.2071 5.29289L5.29289 10.2071C5.10536 10.3946 5 10.649 5 10.9142V15C5 15.5523 5.44771 16 6 16H15C15.5523 16 16 15.5523 16 15Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.5H5V3.19995H2V4.19995H6.84974C6.58183 4.70865 6.15883 5.35375 5.59967 5.94347C5.46184 6.08884 5.31707 6.22945 5.16568 6.36303C4.94895 6.21356 4.76161 6.0545 4.60355 5.89645C4.38179 5.67469 4.22245 5.45962 4.12162 5.28318C4.02417 5.11263 4.00411 5.0185 4.00065 5.00224C4.00016 4.99995 4 4.9992 4 5H3C3 5.25648 3.11454 5.53636 3.25338 5.77932C3.40255 6.04038 3.61821 6.32531 3.89645 6.60355C4.02395 6.73106 4.1656 6.85815 4.32138 6.98163C3.88994 7.23626 3.42059 7.42301 2.9178 7.5068L3.0822 8.4932C3.90107 8.35672 4.62624 8.0114 5.25012 7.57035C5.5879 7.73836 5.96415 7.88143 6.37873 7.98507L6.62127 7.01493C6.44023 6.96967 6.2685 6.91541 6.10606 6.85401C6.18135 6.78056 6.25445 6.70628 6.32533 6.63153C7.13069 5.78216 7.68658 4.83285 7.95829 4.19995H9V3.19995H6V2.5Z",
    fill: "#626262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2895 12.3H9.6895L9.1935 13.5H7.8655L10.3615 7.9H11.6415L14.1455 13.5H12.7855L12.2895 12.3ZM11.8815 11.316L10.9935 9.172L10.1055 11.316H11.8815Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTranslateIconOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/translate-icon-off.4d3e97f6016cb38d6393fe627cecb404.blank.svg";